import { DEFAULT_FONT_SIZE as e } from "../../constants/default-styles.mjs";
import { unsetTextStyleAttribute as t } from "../text-style-extension/utils/unset-text-style-attribute.mjs";
import { useFontSizeExtensionToolbar as n } from "./use-font-size-extension-toolbar.mjs";
import { Extension as r } from "@tiptap/core";
import { Plugin as i, PluginKey as a } from "@tiptap/pm/state";
//#region src/extensions/font-size-extension/index.ts
var o = new a("defaultFontSize"), s = r.create({
	name: "fontSize",
	addOptions() {
		return {
			types: ["textStyle"],
			defaultFontSize: null
		};
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { fontSize: {
				default: null,
				parseHTML: (e) => e.style.fontSize.replace(/['"]+/g, ""),
				renderHTML: (e) => e.fontSize ? { style: `font-size: ${e.fontSize}` } : {}
			} }
		}];
	},
	addCommands() {
		return {
			setFontSize: (e) => ({ chain: t }) => t().setMark("textStyle", { fontSize: e }).run(),
			unsetFontSize: () => ({ tr: e, state: n, dispatch: r }) => t("fontSize", n, e, r)
		};
	},
	addProseMirrorPlugins() {
		let e = this.options.defaultFontSize;
		return e ? [new i({
			key: o,
			appendTransaction: (t, n, r) => {
				if (!t.some((e) => e.docChanged)) return null;
				let i = r.tr, a = !1;
				return r.doc.descendants((t, n) => {
					if (!t.isText) return;
					let o = r.doc.resolve(n).parent, s = o.type.name === "paragraph", c = o.type.name === "listItem", l = o.type.name === "heading";
					if (!s && !c || l) return;
					let u = t.marks.find((e) => e.type.name === "textStyle");
					if (!u?.attrs.fontSize) {
						let o = n, s = n + t.nodeSize, c = r.schema.marks.textStyle;
						if (c) {
							let t = c.create({
								...u?.attrs,
								fontSize: e
							});
							i.addMark(o, s, t), a = !0;
						}
					}
				}), a ? i : null;
			}
		})] : [];
	}
}), c = (t) => s.configure({ defaultFontSize: t?.clearable ? null : e });
//#endregion
export { c as createFontSizeExtension, n as useFontSizeExtensionToolbar };
